import { Box, Grid, Typography } from '@mui/material';
import { SportsTennis, EmojiEvents, People, EventAvailable } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { fetchDashboardStats } from '../services/api';
import StatCard from '../components/dashboard/StatCard';
import TournamentDashboard from '../components/dashboard/TournamentDashboard';
import UpcomingMatches from '../components/dashboard/UpcomingMatches';
import { useAuth } from '../contexts/AuthContext';

const DashboardPage = () => {
  const { user } = useAuth();
  const { data: stats, isLoading, error } = useQuery(['dashboardStats'], fetchDashboardStats);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading dashboard data</div>;

  const isAdmin = user?.['custom:role'] === 'admin';

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>Dashboard</Typography>
      
      {/* Stats Cards - Only show for admin users */}
      {isAdmin && (
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Active Tournaments"
              value={stats?.activeTournaments || 0}
              icon={<EmojiEvents fontSize="large" color="primary" />}
              color="primary"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Upcoming Matches"
              value={stats?.upcomingMatches || 0}
              icon={<SportsTennis fontSize="large" color="secondary" />}
              color="secondary"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Active Players"
              value={stats?.activePlayers || 0}
              icon={<People fontSize="large" color="success" />}
              color="success"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Matches This Week"
              value={stats?.matchesThisWeek || 0}
              icon={<EventAvailable fontSize="large" color="warning" />}
              color="warning"
            />
          </Grid>
        </Grid>
      )}

      {/* Main Content */}
      <Grid container spacing={3}>
        {/* Tournament Dashboard */}
        <Grid item xs={12} md={6}>
          <TournamentDashboard />
        </Grid>
        
        {/* Upcoming Matches */}
        <Grid item xs={12} md={6}>
          <UpcomingMatches />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardPage;
